import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-visibility",
  templateUrl: "./med-icon-visibility.component.html",
})
export class MedIconVisibilityComponent extends SvgMixinComponent {}
